import {ZERO} from "./constants";

const getPageData = elemId => {
	return JSON.parse(document.getElementById(elemId).innerHTML);
};

const linker = (selector = '.js-pseudo-link') => {
	const links = document.querySelectorAll(selector);
	for (let link of links) {
		link.addEventListener('click', el => {
			const linkElem = el.currentTarget;
			const targetSelector = linkElem.dataset.target || '';
			tabs_goto(linkElem.dataset.url, targetSelector);
		})
	}
};

const initVaultLoginLink = vaultId => {
	const vaultLoginBtns = document.querySelectorAll('.js-vault-login');
	vaultLoginBtns.forEach((btn) => {
		btn.addEventListener('click', () => {
			vaultLogin(vaultId || btn.dataset.id);
		});
	});
};

const watchMutations = (selector, mutationOptions, actionFunction) => {
  const observeContainer = document.querySelector(selector);
  if (observeContainer) {
    const observer = new MutationObserver(mutations => {
      for (let mutation of mutations) {
        if (mutation.addedNodes.length > ZERO) {
          actionFunction();
        }
      }
    });
    observer.observe(observeContainer, mutationOptions);
  }
};

export {getPageData, linker, initVaultLoginLink, watchMutations};
